// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1acDb","tab":"ProcedureTabs_tab__3rPXG"};